import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Alert from 'component/utils/Alert'

class DemarcateDisapprovalJustificationEditForm extends Component {
  state = {
    alert: {
      show: false,
      message: '',
    },
  }

  static propTypes = {
    fields: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    justification: PropTypes.object,
    updateJustification: PropTypes.func,
  }

  handleAlert = (message) => {
    this.setState((prevState) => ({
      alert: {
        show: !prevState.alert.show,
        message: message || '',
      },
    }))
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { onSubmit, translate, justification } = this.props

    if (
      !justification.dsDemarcateDisapprovalJustification ||
      justification.dsDemarcateDisapprovalJustification.length === 0
    ) {
      return
    }
    if (justification.dsDemarcateDisapprovalJustification.length > 250) {
      let msg = translate('demarcate.disapproval.dsJustificationMaxSize')
      msg = msg.replace('#', '250')
      this.handleAlert(msg)
      return
    }
    onSubmit(justification)
  }

  handleChange = (e) => {
    const { updateJustification, justification } = this.props
    updateJustification({
      ...justification,
      dsDemarcateDisapprovalJustification: e.target.value,
    })
  }

  handleClean = () => {
    const { updateJustification } = this.props
    updateJustification({ dsDemarcateDisapprovalJustification: '' })
  }

  render() {
    const { translate, justification } = this.props
    const field = this.props.fields

    const { alert } = this.state

    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col lg={6} lgOffset={3} md={6} mdOffset={3} sm={12} xs={12}>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Field {...field.dsDemarcateDisapprovalJustification}>
                <Input
                  id='dsDemarcateDisapprovalJustification'
                  {...field.dsDemarcateDisapprovalJustification.input}
                  value={justification.dsDemarcateDisapprovalJustification}
                  onChange={(e) => this.handleChange(e)}
                />
              </Field>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {justification.idDemarcateDisapprovalJustification
                  ? translate('demarcate.disapproval.update')
                  : translate('demarcate.disapproval.register')}
              </button>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='button'
                className='button-hollow button-hollow-danger button-full align-center'
                onClick={() => this.handleClean()}
              >
                {translate('demarcate.disapproval.clean')}
              </button>
            </Col>
          </Col>
        </Row>

        {alert.show && (
          <Alert
            handleAlert={this.handleAlert}
            text={translate(alert.message)}
            translate={translate}
            textButton={translate('irc.gama.closeAlert')}
            preventDefault
            size='sm'
          />
        )}
      </form>
    )
  }
}

const fields = ['dsDemarcateDisapprovalJustification']

export default Form({ fields })(DemarcateDisapprovalJustificationEditForm)

export { DemarcateDisapprovalJustificationEditForm }
